import { useContext } from "react";
import { FilterContext } from "../providers/FilterProvider";
import { hasPermissionExist } from "../store/api/permissions";
export var COHORT_CONFIDENTIAL_PERMISSION = "COHORT_INSIGHTS_API/COHORT_CONFIDENTIAL";
/**
 * Single source of truth for confidential-report view state.
 *
 * Filters are disabled only in the default Confidential Client Version. When an
 * admin with confidential permission switches to the Heidrick Validation
 * Version (`confidential` filter set to "false"), filters are re-enabled and
 * the backend returns leader-level chart data.
 */
export var useConfidentialReportView = function (isConfidentialReport) {
    var getFilters = useContext(FilterContext).getFilters;
    var hasPermission = hasPermissionExist(COHORT_CONFIDENTIAL_PERMISSION);
    var filters = (getFilters() || {});
    var confidential = filters.confidential;
    var isNonConfidentialMode = Array.isArray(confidential) && confidential[0] === "false";
    var confidentialReport = !!isConfidentialReport;
    var isValidationView = confidentialReport && hasPermission && isNonConfidentialMode;
    var isConfidentialView = confidentialReport && !isValidationView;
    return {
        isConfidentialReport: confidentialReport,
        hasPermission: hasPermission,
        isValidationView: isValidationView,
        isConfidentialView: isConfidentialView,
        disableFilters: isConfidentialView,
    };
};
